import {css} from 'aphrodite';
import {Position, HandleProps, HandleType} from 'reactflow';

import {NODE_HEADER_HANDLE_STYLES} from './BenchlingNodeDesignConstants';

export function defaultHandleProps(
  handleType: HandleType
): Pick<HandleProps, 'position' | 'type'> & {className: string} {
  return {
    className: css(
      NODE_HEADER_HANDLE_STYLES.nodeHandle,
      handleType === 'target' ? NODE_HEADER_HANDLE_STYLES.leftHandle : NODE_HEADER_HANDLE_STYLES.rightHandle
    ),
    position: handleType === 'target' ? Position.Left : Position.Right,
    type: handleType,
  };
}
